<template>
  <div class="preview-item_free" v-if="isDisplay"
       :style="{'padding-left': paddingLeft}">
      <preview-item-template v-for="(el) in formNode.children" 
                            :key="el.id" 
                            :formNode="el"
                            :parent="formNode.children">
      </preview-item-template>
  </div>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ],
  watch: {
    /** @name 监听显示/隐藏事件
     *  @param {Boolean} { true:显示，false:隐藏 }
     *  @author 王汝鹏
     *  @version 2019-12-29
     */ 
    isDisplay(newValue) {
        /** @name 表单项节点迭代方法
         *  @param {Object} formNode 表单项节点
         *  @author 王汝鹏 
         *  @version 2020-01-04
         */
        
        const iteration = (formNode) => {
          let formConfig = this.formMap[formNode.id];
          let { baseOption, node } = formConfig || {};
          let { type } = node || {};
          let { model } = baseOption || {};
          if (Reflect.has(this.formModels, model) && this.formModels[model]) { 
            switch(true) {
              case (Array.isArray(this.formModels[model])): (this.formModels[model].length>0) && (this.formModels[model] = []); break;
              case Boolean(this.formModels[model]): this.formModels[model] = undefined; break;
            }
          }

          for (let node of formNode.children) { iteration(node); }
        }
        this.toggleClearModelState == true && iteration(this.formNode);
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemFree.vue